import * as React from "react";

export const useStickyFooterHeight = (enabled: boolean) => {
  const footerRef = React.useRef<HTMLDivElement | null>(null);
  const [footerH, setFooterH] = React.useState(0);

  React.useLayoutEffect(() => {
    if (!enabled) return;
    const measure = () => setFooterH(footerRef.current?.offsetHeight ?? 0);
    measure();
    const ro = new ResizeObserver(measure);
    if (footerRef.current) ro.observe(footerRef.current);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [enabled]);

  return { footerRef, footerH };
};
